import ApisServiceApp from '@api/ApisServiceApp'
import { ICategory } from '@interfaces/categoryInterfaces'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

export function createCategory(data: ICategory) {
  try {
    return ApisServiceApp.post('/category/create-category', data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function updateCategory(data: ICategory) {
  try {
    return ApisServiceApp.put('/category/' + data.id + '/update-category', data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getDetailCategory(id: string) {
  try {
    return ApisServiceApp.get('/category/' + id + '/get-chitiet-category')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getListCategory(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/category/filter-category', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getListOptionCategory(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/category/filter-category', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteCategory(id: string) {
  try {
    return ApisServiceApp.delete('/category/' + id + '/delete-category')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteMultiCategory(idArr: Array<string>) {
  try {
    return ApisServiceApp.delete('/category/bulk-delete-category', { data: idArr })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
